webpackJsonp([36],{

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_personal_data_vue__ = __webpack_require__(339);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ecda746_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_personal_data_vue__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(61);
function injectStyle (context) {
  __webpack_require__(451)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ecda746"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_personal_data_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ecda746_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_personal_data_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ecda746_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_personal_data_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PersonalData',
  data: function data() {
    return {
      name: '',
      gender: '',
      documentType: '二代身份证',
      idNumber: '',
      phone: '',
      card: '',
      hospital: ''
    };
  },
  mounted: function mounted() {
    this.getInfo();
  },

  methods: {
    // 获取就诊卡信息
    getInfo: function getInfo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var hospitalId, id, response, arr, i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                hospitalId = _this.$route.query.hospital;
                id = _this.$route.query.id;
                _context.next = 4;
                return _this.$http.get('/patient-api/webapi/user/list-medical-card', {
                  params: {
                    access_token: __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('token'),
                    hospital_id: hospitalId
                  },
                  headers: {
                    Authorization: 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('token')
                  }
                });

              case 4:
                response = _context.sent;
                arr = response.list;

                for (i = 0; i < arr.length; i += 1) {
                  if (id === arr[i].id) {
                    _this.name = arr[i].name;
                    _this.gender = arr[i].sex;
                    _this.idNumber = arr[i].id_card_code;
                    _this.phone = arr[i].phone;
                    _this.card = arr[i].medical_card_id;
                    _this.hospital = arr[i].hospital_flag;
                  }
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // 取消绑定就诊卡
    unbindCard: function unbindCard() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var hospitalId, params, url, config;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                hospitalId = _this2.$route.query.hospital;
                params = {
                  medical_card_id: _this2.card,
                  hospital_id: hospitalId
                };
                url = '/patient-api/webapi/user/unbind-medical-card?hospital_id=' + hospitalId;
                config = {
                  headers: {
                    Authorization: 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('token')
                  }
                };
                _context2.next = 6;
                return _this2.$http.post(url, params, config);

              case 6:
                _this2.$router.go(-1);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(169).default
var update = add("6f66f500", content, true, {});

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".info-container[data-v-9ecda746]{margin-top:5px}.info-border[data-v-9ecda746]{border-bottom:1px solid #dee2e6}", "", {"version":3,"sources":["F:/1.前端/ykb-weixin/src/views/user/personal-data.vue"],"names":[],"mappings":"AACA,iCACE,cAAe,CAChB,AACD,8BACE,+BAAiC,CAClC","file":"personal-data.vue","sourcesContent":["\n.info-container[data-v-9ecda746]{\n  margin-top:5px;\n}\n.info-border[data-v-9ecda746]{\n  border-bottom: 1px solid #dee2e6;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-container"},[_c('div',{staticClass:"info-border"},[_c('mt-cell',{attrs:{"title":"姓名"}},[_c('p',[_vm._v(_vm._s(_vm.name))])])],1),_vm._v(" "),_c('div',{staticClass:"info-border"},[_c('mt-cell',{attrs:{"title":"性别"}},[_c('p',[_vm._v(_vm._s(_vm.gender))])])],1),_vm._v(" "),_c('div',{staticClass:"info-border"},[_c('mt-cell',{attrs:{"title":"证件类型"}},[_c('p',[_vm._v(_vm._s(_vm.documentType))])])],1),_vm._v(" "),_c('div',{staticClass:"info-border"},[_c('mt-cell',{attrs:{"title":"证件号"}},[_c('p',[_vm._v(_vm._s(_vm.idNumber))])])],1),_vm._v(" "),_c('div',{staticClass:"info-border"},[_c('mt-cell',{attrs:{"title":"手机"}},[_c('p',[_vm._v(_vm._s(_vm.phone))])])],1),_vm._v(" "),_c('div',{staticClass:"info-border"},[_c('mt-cell',{attrs:{"title":"就诊卡号"}},[_c('p',[_vm._v(_vm._s(_vm.card))])])],1),_vm._v(" "),_c('div',[_c('mt-cell',{attrs:{"title":"所属医院"}},[_c('p',[_vm._v(_vm._s(_vm.hospital))])])],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"30px 10px"}},[_c('mt-button',{attrs:{"type":"primary","size":"large"},on:{"click":_vm.unbindCard}},[_vm._v("解绑就诊卡")])],1)])}
var staticRenderFns = []


/***/ })

});


// WEBPACK FOOTER //
// static/js/36.3d0c49c1e5987506b65a.js